@if (hasErrors()) {
  <div class="inwi-error-container">
    <div class="inwi-text-error font-regular-label-large">
      {{ getErrorMessage() }}
    </div>
  </div>
}
